import { apiClient } from "shared/utils";
import { format } from "date-fns";
import { RegainsRequest, RegainsResponse } from "api/models";

export const getRegainsData = async ({
  shopId,
  page,
  pageSize,
  startDate,
  endDate,
  sortDirection,
  sortKey,
  searchValue
}: RegainsRequest) => {
  const { data } = await apiClient.get<RegainsResponse>(`/${shopId}/dashboard/regains`, {
    params: {
      page: page + 1, // API is 1-indexed
      pageSize,
      sortKey,
      sortDirection,
      startDate: format(startDate, "yyyy-MM-dd"),
      endDate: format(endDate, "yyyy-MM-dd"),
      search: searchValue
    }
  });

  return data;
};
